import React from 'react'
import ReactMarkdown from 'utils/markdown'
import SectionType from 'models/types/ts/sectionType'
import CTA from 'features/jumbotron/components/cta'
import { Container } from 'layouts'
import { HeadingMedium, HeadingSmall } from 'layouts/typography'
import cx from 'classnames'
import { CSSProperties } from 'styled-components'
import { ThemeContext } from '../../context'
import style from './CTATemplate.module.scss'

interface Props {
    section: SectionType
}

const CTATemplate = ({ section }: Props): JSX.Element => {
    if (!section) return <></>
    const hasBackgroundImage = section?.imageFile?.url
    return (
        <Container
            style={
                {
                    '--background-image-height': `${
                        section?.imageFile?.height || 0
                    }px`,
                } as CSSProperties
            }
            className={cx(
                style.cta,
                hasBackgroundImage ? style.withBackground : ''
            )}
        >
            {hasBackgroundImage && (
                <div className={style.backgroundImageWrapper}>
                    <img
                        className={style.backgroundImage}
                        src={section.imageFile.url}
                        alt={section.imageFile.description}
                    />
                </div>
            )}
            <ReactMarkdown
                className={style.text}
                source={section.body}
                escapeHtml={false}
                renderers={{
                    h1: ({ children }): JSX.Element => (
                        <HeadingMedium as="h1">{children}</HeadingMedium>
                    ),
                    h2: ({ children }): JSX.Element => (
                        <HeadingMedium as="h2">{children}</HeadingMedium>
                    ),
                    h3: ({ children }): JSX.Element => (
                        <HeadingSmall as="h3">{children}</HeadingSmall>
                    ),
                    h4: ({ children }): JSX.Element => (
                        <HeadingSmall as="h4">{children}</HeadingSmall>
                    ),
                    // It was like this before react-markdown upgrade, keeping for reference, delete commented next time you see this
                    // heading: ({ children, level }) =>
                    //     level === 2 ? (
                    //         <HeadingMedium as="h2">{children}</HeadingMedium>
                    //     ) : (
                    //         <HeadingSmall as="h3">{children}</HeadingSmall>
                    //     ),
                }}
            />
            <div className={style.content}>
                <ThemeContext.Consumer>
                    {(colorTheme) => (
                        <CTA
                            section={section.contentCollection.items}
                            data-id="dynamic-bottom-cta-button"
                            className={style.buttons}
                            yellowClassName={style.yellow}
                            custom={{
                                color: colorTheme.CTA.color,
                                background: colorTheme.CTA.background,
                            }}
                        />
                    )}
                </ThemeContext.Consumer>
            </div>
        </Container>
    )
}

export default CTATemplate
